export default __webpack_public_path__ + "static/media/badge.ad1c375d.png";